import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CREATE_USER,
  EDIT_USER,
  LOAD_USERS_LIST,
} from './user';
import {
  LOAD_SCRIPTS_LIST,
  LOAD_TOR_NODES_LIST,
  RESTART_SCRIPT,
  RESTART_TOR_NODE,
  RESTART_TOR_SERVICE, STOP_SCRIPT
} from "./server";


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users',
  [EDIT_USER]: 'api/users/:id:',
  [LOAD_TOR_NODES_LIST]: 'api/tor/nodes',
  [RESTART_TOR_NODE]: 'api/tor/nodes/restart/:id:',
  [RESTART_TOR_SERVICE]: 'api/tor/service/restart',
  [LOAD_SCRIPTS_LIST]: 'api/scripts',
  [RESTART_SCRIPT]: 'api/scripts/restart/:id:',
  [STOP_SCRIPT]: 'api/scripts/stop/:id:',
};
export default path;
